import React from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { IMG_EMPTY_NOTIFICATIONS } from 'images';

const useStyles = makeStyles({
  emptyNotificationsText: {
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0.49px',
    color: 'rgba(0,0,0,0.87)',
  },
  emptyNotificationsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  emptyNotificationsImage: {
    padding: '55px 0 24px',
  },
});

export const EmptyNotification = () => {
  const classes = useStyles();

  return (
    <Grid item xs={12} classes={{ root: classes.emptyNotificationsContainer }}>
      <img
        src={IMG_EMPTY_NOTIFICATIONS}
        alt="No New Notifications"
        className={classes.emptyNotificationsImage}
      />
      <Typography classes={{ root: classes.emptyNotificationsText }}>
        All notifications are caught up.
      </Typography>
    </Grid>
  );
};
